import request from '@/utils/request'

const getRd = (params) => {
  return request({
    url: '/shop/home/rd',
    params,
    method: 'get'
  })
}

export {
  getRd // 获取推荐商品
}
